<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import keycloakService, {
  isAuthenticated,
  keycloakIsDisabled,
  autoLoginEnabled,
  keycloakInitialized,
} from '../utils/KeycloakService';
import SkeletonLoader from './SkeletonLoader.svelte';

export let onLoginSuccess = () => {};
export let onLoginError = () => {};

// React to authentication state changes
$: if ($isAuthenticated) {
  onLoginSuccess();
}

function handleLogin() {
  keycloakService.login();
}

function handleLogout() {
  keycloakService.logout();
}
</script>
{#if !$keycloakIsDisabled}
  {#if !$keycloakInitialized}
    <SkeletonLoader type="button"/>
  {:else}
    <div class="login-container">
      {#if $isAuthenticated}
        <button on:click={() => handleLogout()}>Logout</button>
      {:else if !$autoLoginEnabled}
        <button on:click={() => handleLogin()}>Login</button>
      {/if}
    </div>
  {/if}
{/if}

<style>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  button {
    background-color: var(--main-color, #3498db);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
  }

  button:hover {
    background-color: var(--sec-color, #2980b9);
  }
</style>
